// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var PriceListEditController = function ($rootScope,
                                        $scope,
                                        $location,
                                        $routeParams,
                                        $q,
                                        $modal,
                                        ProductInfo,
                                        PriceList,
                                        PriceListItems,
                                        babelFilter) {
    
    if (!$scope.search)
        $scope.search = "";
    if (!$scope.searchRecurringComponents)
        $scope.searchRecurringComponents = "";
    if (!$scope.searchMeteredComponents)
        $scope.searchMeteredComponents = "";
    var initialPriceTaxType = 'Net';
    var initialBillingPrecision = 'Precise';

    $scope.unsavedItems = {value: 0};
    $scope.unsavedRecurringComponentItems = {value: 0};
    $scope.unsavedMeteredComponentItems = {value: 0};
    $scope.clonedPlanVariantPriceListItems = [];
    $scope.clonedRecurringComponentsPriceListItems = [];
    $scope.clonedMeteredComponentsPriceListItems = [];
    
    $scope.pricesAssignedParameter = $scope.pricesAssignedRecurringComponentsParameter = $scope.pricesAssignedMeteredComponentsParameter = null;
    $scope.pricesAssigned = $scope.pricesAssignedRecurringComponents = $scope.pricesAssignedMeteredComponents = "All";
    
    $scope.getPriceListExtendedName = function (pList) {
        return $scope.priceList && $scope.priceList.Id ? '' : ' (' + pList.PriceTaxType +' | ' + pList.TimeGranularity +')';
    };
    if ($routeParams.priceListId) {
        $scope.productInfo = ProductInfo.get(function () {
            $scope.priceList = Object.assign(new PriceList(), $scope.productInfo.PriceLists.find(pl => pl.Id === $routeParams.priceListId));
            if (!$scope.priceList) { //never should happen, but just in case...
                console.error(`Price list with id ${$routeParams.priceListId} not found.`);
                $location.path("/products");
                return;
            }

            const parentPriceListId = $scope.priceList.ParentPriceListId;
            if (parentPriceListId) {
                $scope.parentPriceList = getParentPriceList(parentPriceListId);
            }

            LoadPricesAndUpdateFilters(!!parentPriceListId);
        }, true);
    } else {
        $scope.priceList = new PriceList();
        $scope.priceList.PlanGroupId = $routeParams.planGroupId;

        $scope.productInfo = ProductInfo.get(function () {
        }, true);
    }

    function getParentPriceList(parentPriceListId) {
        let parentPriceList = $scope.productInfo.PriceLists.find(pl => pl.Id === parentPriceListId);

        if (!parentPriceList) {
            return null;
        }

        if (parentPriceList.Items != null && parentPriceList.Items.length) {
            return parentPriceList;
        }
        
        return parentPriceList.ParentPriceListId
            ? getParentPriceList(parentPriceList.ParentPriceListId)
            : parentPriceList;
    }

    function LoadPricesAndUpdateFilters(isChildPriceList) {
        // Do nothing until data is loaded
        if (!$scope.priceList.Items && (isChildPriceList || !$scope.parentPriceList.Items)) {
            return;
        }

        $scope.loadPlanVariantsPrices();
        $scope.loadRecurringComponentsPrices();
        $scope.loadMeteredComponentsPrices();
        $scope.updateFilter();
        $scope.updateRecurringComponentsFilter();
        $scope.updateMeteredComponentsFilter();
    }

    $scope.loadPlanVariantsPrices = function () {
        $scope.loadedPlanVariantsPricesPerPriceList =
            $scope.productInfo.PlanVariantsByPlanGroupId($scope.priceList.PlanGroupId).map(obj => ({
            ...GetPriceListItemByProductId(obj.Id),
            Id: obj.Id,
            ProductId: obj.Id,
            PriceListId: $scope.priceList.Id,
        }));
    };

    $scope.loadRecurringComponentsPrices = function () {
        $scope.loadedRecurringComponentsPricesPerPriceList = 
            $scope.productInfo.ComponentsByPlanGroupId($scope.priceList.PlanGroupId)
                .filter(component => component.ComponentType != "Metered")
                .map(obj => ({
                    ...GetPriceListItemByProductId(obj.Id),
                    Id: obj.Id,
                    ProductId: obj.Id,
                    PriceListId: $scope.priceList.Id,
                }));
    };

    $scope.loadMeteredComponentsPrices = function () {
        $scope.loadedMeteredComponentsPricesPerPriceList = 
            $scope.productInfo.ComponentsByPlanGroupId($scope.priceList.PlanGroupId)
                .filter(component => component.ComponentType == "Metered")
                .map(obj => ({
                    ...GetPriceListItemByProductId(obj.Id),
                    Id: obj.Id,
                    ProductId: obj.Id,
                    PriceListId: $scope.priceList.Id,
                }));
    };

    function GetPriceListItemByProductId(productId) {
        let priceListItem = $scope.priceList.Items.find(i => i.ProductId === productId);
        const parentPriceListId = $scope.priceList.ParentPriceListId;

        if (parentPriceListId) {
            const parentPriceListItem = getItemFromParent(parentPriceListId, productId);

            // If item is not found in Child PL and found in Parent PL it's inherited
            if (!priceListItem && parentPriceListItem) {
                priceListItem = parentPriceListItem;
                priceListItem.IsOverridden = false;
            } else if (priceListItem)
                priceListItem.IsOverridden = true;
        } else if (priceListItem) // If PL is not child, item is never overridden
            priceListItem.IsOverridden = false;

        if (!priceListItem)
            return {};

        return JSON.parse(JSON.stringify(priceListItem));
    }

    function getItemFromParent(parentPriceListId, productId) {
        if (!parentPriceListId || !productId) {
            return null;
        }
        var priceListItem = null;
        var parentPriceList = $scope.productInfo.PriceLists.find(pl => pl.Id === parentPriceListId);
        var parentPriceListItem = parentPriceList.Items.find(pl => pl.ProductId === productId);
        if (parentPriceListItem) {
            priceListItem = parentPriceListItem;
        } else if (!parentPriceListItem && parentPriceList.ParentPriceListId) {
            priceListItem = getItemFromParent(parentPriceList.ParentPriceListId, productId);
        }
        return priceListItem;
    }

    function filterDataByFields(searchValue, getValuesToSearchIn) {
        if (!searchValue)
            return true;
        let searchInValues = getValuesToSearchIn();
        for (let i = 0; i < searchInValues.length; i++) {
            if (stringContainsValue(searchInValues[i], searchValue))
                return true;
        }
        return false;
    }

    function stringContainsValue(string, value) {
        if (!string)
            return false;
        return string.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }

    $scope.updateFilter = function () {
        $scope.fullPlanVariantsPricesPerPriceList = $scope.loadedPlanVariantsPricesPerPriceList.filter(obj => {
            let planVariant = $scope.productInfo.PlanVariantById(obj.Id);
            let plan = $scope.productInfo.PlanById(planVariant.PlanId);
            return isPriceUndefined(obj, $scope.pricesAssignedParameter) && plan != null && planVariant != null && !plan.Hidden && !planVariant.Hidden &&
                filterDataByFields($scope.search, function () { return [planVariant.InternalName, babelFilter(plan.Name)]; });
        });
        $scope.planVariantsPricesPerPriceList = $scope.paginator(function (options, callback) {
            let list = null;
            let index = 0;
            if (options.from !== "") {
                index = $scope.fullPlanVariantsPricesPerPriceList.findIndex(x => x.Id === options.from)
            }
            list = $scope.fullPlanVariantsPricesPerPriceList.slice(index, index + options.take);
            let query = function (success) {
                let deferred = $q.defer();
                let promise = deferred.promise;
                promise.then(success);
                deferred.resolve(list);
                return promise.$$state.value;
            };
            return query(function () {
                if ($scope.unsavedItems.value > 0) {
                    return;
                }
                callback();
                setupDirtyPlanVariantsPerPriceList();
                $scope.clonedPlanVariantPriceListItems = JSON.parse(JSON.stringify($scope.planVariantsPricesPerPriceList.items));
            });
        }, null, 20);
        
        $scope.planVariantsPricesPerPriceList.first = $scope.overrideStep($scope.planVariantsPricesPerPriceList.first, $scope.unsavedItems);
        $scope.planVariantsPricesPerPriceList.next = $scope.overrideStep($scope.planVariantsPricesPerPriceList.next, $scope.unsavedItems);
        $scope.planVariantsPricesPerPriceList.prev = $scope.overrideStep($scope.planVariantsPricesPerPriceList.prev, $scope.unsavedItems);
    };

    $scope.updateRecurringComponentsFilter = function () {
        $scope.fullRecurringComponentsPricesPerPriceList = $scope.loadedRecurringComponentsPricesPerPriceList
            .filter(obj => isPriceUndefined(obj, $scope.pricesAssignedRecurringComponentsParameter) &&
                        filterDataByFields($scope.searchRecurringComponents, function () { return [babelFilter($scope.productInfo.ComponentById(obj.Id).Name)]; })
                );
        $scope.recurringComponentsPricesPerPriceList = $scope.paginator(function (options, callback) {
            let list = null;
            let index = 0;
            if (options.from !== "") {
                index = $scope.fullRecurringComponentsPricesPerPriceList.findIndex(x => x.Id === options.from)
            }
            list = $scope.fullRecurringComponentsPricesPerPriceList.slice(index, index + options.take);

            let query = function (success) {
                let deferred = $q.defer();
                let promise = deferred.promise;
                promise.then(success);
                deferred.resolve(list);
                return promise.$$state.value;
            };
            return query(function () {
                if ($scope.unsavedRecurringComponentItems.value > 0) {
                    return;
                }
                callback();
                setupDirtyRecurringComponentsPerPriceList();
                $scope.clonedRecurringComponentsPriceListItems = JSON.parse(JSON.stringify($scope.recurringComponentsPricesPerPriceList.items));
            });
        }, null, 20);
        
        $scope.recurringComponentsPricesPerPriceList.first = $scope.overrideStep($scope.recurringComponentsPricesPerPriceList.first, $scope.unsavedRecurringComponentItems);
        $scope.recurringComponentsPricesPerPriceList.next = $scope.overrideStep($scope.recurringComponentsPricesPerPriceList.next, $scope.unsavedRecurringComponentItems);
        $scope.recurringComponentsPricesPerPriceList.prev = $scope.overrideStep($scope.recurringComponentsPricesPerPriceList.prev, $scope.unsavedRecurringComponentItems);
    };

    $scope.updateMeteredComponentsFilter = function () {
        $scope.fullMeteredComponentsPricesPerPriceList = $scope.loadedMeteredComponentsPricesPerPriceList
            .filter(obj => isPriceUndefined(obj, $scope.pricesAssignedMeteredComponentsParameter) &&
                    filterDataByFields($scope.searchMeteredComponents, function () { return [babelFilter($scope.productInfo.ComponentById(obj.Id).Name)]; })
                );
        $scope.meteredComponentsPricesPerPriceList = $scope.paginator(function (options, callback) {
            let list = null;
            let index = 0;
            if (options.from !== "") {
                index = $scope.fullMeteredComponentsPricesPerPriceList.findIndex(x => x.Id === options.from)
            }
            list = $scope.fullMeteredComponentsPricesPerPriceList.slice(index, index + options.take);

            let query = function (success) {
                var deferred = $q.defer();
                var promise = deferred.promise;
                promise.then(success);
                deferred.resolve(list);
                return promise.$$state.value;
            };
            return query(function () {
                if ($scope.unsavedMeteredComponentItems.value > 0) {
                    return;
                }
                callback();
                setupDirtyMeteredComponentsPerPriceList();
                $scope.clonedMeteredComponentsPriceListItems = JSON.parse(JSON.stringify($scope.meteredComponentsPricesPerPriceList.items));
            });
        }, null, 20);
        
        $scope.meteredComponentsPricesPerPriceList.first = $scope.overrideStep($scope.meteredComponentsPricesPerPriceList.first, $scope.unsavedMeteredComponentItems);
        $scope.meteredComponentsPricesPerPriceList.next = $scope.overrideStep($scope.meteredComponentsPricesPerPriceList.next, $scope.unsavedMeteredComponentItems);
        $scope.meteredComponentsPricesPerPriceList.prev = $scope.overrideStep($scope.meteredComponentsPricesPerPriceList.prev, $scope.unsavedMeteredComponentItems);
    };

    function isPriceUndefined(priceListItem, pricesAssigned) {
        var emptyPrice = priceListItem.OneOffPrice == null && priceListItem.RecurringPrice == null;
        return pricesAssigned == null || (emptyPrice && !pricesAssigned) || (!emptyPrice && pricesAssigned);
    }

    function setupDirtyPlanVariantsPerPriceList() {
        $scope.planVariantsPricesPerPriceList.items.map(function (x) {
            x.dirty = false;
        });
        $scope.unsavedItems.value = 0;
        $scope.$watch(function () {
            return $scope.planVariantsPricesPerPriceList.items;
        }, function (newCollection, oldCollection) {
            let difference = newCollection.filter(function (newItem) {
                let result = true;
                oldCollection.forEach(function (oldItem) {
                    if (angular.equals(newItem, oldItem)) result = false;
                });
                return result;
            });

            difference.forEach(function (newValue) {
                const oldValue = oldCollection.find(x => x.Id === newValue.Id);
                if (oldValue && oldValue.dirty === false && newValue.dirty === false) {
                    $scope.unsavedItems.value++;
                    newValue.dirty = true;
                }
                if(oldValue?.RecurringPrice?.PricePerUnit !== "0" && newValue?.RecurringPrice && newValue?.RecurringPrice?.PricePerUnit === "0"){
                    newValue.RecurringPrice.PricePerUnit = null;
                }
                if(oldValue?.OneOffPrice?.PricePerUnit !== "0" && newValue?.OneOffPrice && newValue?.OneOffPrice?.PricePerUnit === "0"){
                    newValue.OneOffPrice.PricePerUnit = null;
                }
            });
        }, true)
    }

    function setupDirtyRecurringComponentsPerPriceList() {
        $scope.recurringComponentsPricesPerPriceList.items.map(function (x) {
            x.dirty = false;
        });
        $scope.unsavedRecurringComponentItems.value = 0;
        $scope.$watch(function () {
            return $scope.recurringComponentsPricesPerPriceList.items;
        }, function (newCollection, oldCollection) {
            let difference = newCollection.filter(function (newItem) {
                let result = true;
                oldCollection.forEach(function (oldItem) {
                    if (angular.equals(newItem, oldItem)) result = false;
                });
                return result;
            });

            difference.forEach(function (newValue) {
                const oldValue = oldCollection.find(x => x.Id === newValue.Id);
                if (oldValue && oldValue.dirty === false && newValue.dirty === false) {
                    $scope.unsavedRecurringComponentItems.value++;
                    newValue.dirty = true;
                }
            });
        }, true)
    }

    function setupDirtyMeteredComponentsPerPriceList() {
        $scope.meteredComponentsPricesPerPriceList.items.map(function (x) {
            x.dirty = false;
        });
        $scope.unsavedMeteredComponentItems.value = 0;
        $scope.$watch(function () {
            return $scope.meteredComponentsPricesPerPriceList.items;
        }, function (newCollection, oldCollection) {
            let difference = newCollection.filter(function (newItem) {
                let result = true;
                oldCollection.forEach(function (oldItem) {
                    if (angular.equals(newItem, oldItem)) result = false;
                });
                return result;
            });

            difference.forEach(function (newValue) {
                const oldValue = oldCollection.find(x => x.Id === newValue.Id);
                if (oldValue && oldValue.dirty === false && newValue.dirty === false) {
                    $scope.unsavedMeteredComponentItems.value++;
                    newValue.dirty = true;
                }
            });
        }, true)
    }

    $scope.overrideStep = function (step, unsavedItems) {
        const oldStep = step;
        return function () {
            if (unsavedItems.value) {
                let modalInstance = $modal.open({
                    templateUrl: 'error-dialog.html',
                    controller: ['$scope', '$uibModal', 'error', function ($scope, $modalInstance, error) {
                        $scope.error = error;

                        $scope.close = function () {
                            modalInstance.close();
                        };
                    }],
                    windowClass: "fade in",
                    resolve: {
                        error: function () {
                            return "You have made changes on this page which are not saved yet. Please save current page or cancel changes before changing page";
                        }
                    }
                });
                return;
            }
            oldStep();
        }
    }

    $scope.pricesAssignedChanged = function () {
        $scope.pricesAssignedParameter = $scope.pricesAssigned == "All" ? null : $scope.pricesAssigned == "WithPrices";
        $scope.updateFilter();
    };

    $scope.pricesAssignedRecurringComponentsChanged = function () {
        $scope.pricesAssignedRecurringComponentsParameter = $scope.pricesAssignedRecurringComponents == "All" ? null : $scope.pricesAssignedRecurringComponents == "WithPrices";
        $scope.updateRecurringComponentsFilter();
    };

    $scope.pricesAssignedMeteredComponentsChanged = function () {
        $scope.pricesAssignedMeteredComponentsParameter = $scope.pricesAssignedMeteredComponents == "All" ? null : $scope.pricesAssignedMeteredComponents == "WithPrices";
        $scope.updateMeteredComponentsFilter();
    };

    function clearDirty(collection, unsavedItems) {
        collection.items.map(function (x) {
            x.dirty = false;
            x.RequestedAction = undefined;
        });
        unsavedItems.value = 0;
    }

    function finish() {
        $location.path("/plangroups/" + $scope.priceList.PlanGroupId + "/pricelists");
    }

    $scope.save = function() {
        if (!$rootScope.isValid($scope.form))
            return;
        if ($routeParams.priceListId)
            $scope.priceList.$update({ priceListId: $routeParams.priceListId }, finish);
        else
            $scope.priceList.$save({ }, finish);
    };

    $scope.cancel = finish;

    $scope.savePrices = function (collection, unsavedItems, componentIsMattered) {
        const dirtyData = {
            PriceListItems: collection.items.filter(x => x.RequestedAction !== priceListItemActionEnum.Inherit && x.dirty === true),
            RemovePriceListItems: collection.items.filter(x => x.RequestedAction === priceListItemActionEnum.Inherit && x.dirty === true),
        };

        if (dirtyData.PriceListItems.length === 0 && dirtyData.RemovePriceListItems.length === 0) {
            return;
        }
        PriceListItems.update(dirtyData, function() {
            dirtyData.PriceListItems.forEach((item) => {
                let itemsToUpdate = $scope.priceList.Items.filter(priceListItem => priceListItem.ProductId === item.ProductId);
                let itemToUpdate = itemsToUpdate?.length ? itemsToUpdate[0] : {ProductId: item.ProductId};
                if (item.OneOffPrice)
                    itemToUpdate.OneOffPrice = JSON.parse(JSON.stringify(item.OneOffPrice));
                itemToUpdate.RecurringPrice = JSON.parse(JSON.stringify(null));
                item.IsOverridden = $scope.IsChildPriceList();
            });
            dirtyData.RemovePriceListItems.forEach((item) => {
                const parentItem = getItemFromParent($scope.priceList.ParentPriceListId, item.ProductId);
                if (parentItem)
                    item.IsOverridden = false;
            });
            clearDirty(collection, unsavedItems);
            if (componentIsMattered === true)
                $scope.clonedMeteredComponentsPriceListItems = JSON.parse(JSON.stringify(collection.items));
            else if (componentIsMattered === false)
                $scope.clonedRecurringComponentsPriceListItems = JSON.parse(JSON.stringify(collection.items));
            else
                $scope.clonedPlanVariantPriceListItems = JSON.parse(JSON.stringify(collection.items));
        });
    };
    
    $scope.getParentPriceLists = function () {
        return (!$scope.productInfo || !$scope.productInfo.PriceLists)
            ? []
            : $scope.productInfo.PriceLists
            .filter(priceList => priceList.PlanGroupId === $scope.priceList.PlanGroupId
                && priceList.Id !== $scope.priceList.Id);
    };
    
    $scope.onParentPriceListChange = function () {
        let parentPL = $scope.productInfo.PriceLists
            .filter(priceList => priceList.Id === $scope.priceList.ParentPriceListId)[0];
        $scope.priceList.Currency = parentPL.Currency;
        $scope.priceList.PriceTaxType = parentPL.PriceTaxType;
        $scope.priceList.TimeGranularity = parentPL.TimeGranularity; 
        $scope.priceTaxTypeWasChanged = false;
        $scope.billingPrecisionWasChanged = false;
        $scope.parentPriceList.Items = parentPL.Items;
    };

    $scope.showPriceTaxTypeChangedInfoBox = function (newVal) {
        if ($routeParams.priceListId) {
            $scope.priceTaxTypeWasChanged = initialPriceTaxType !== newVal;
        }
    };

    $scope.showBillingPrecisionChangedInfoBox = function (newVal) {
        if ($routeParams.priceListId) {
            $scope.billingPrecisionWasChanged = initialBillingPrecision !== newVal;
        }
    };

    $scope.setActiveTab = function (selTab) {
        $scope.selectedTab = selTab;
    };

    const priceListItemActionEnum = Object.freeze({
        "Define": "Define",
        "Override": "Override",
        "Inherit": "Inherit"
    });

    $scope.DefinePrice = function (item, isComponent) {
        ResetPrice(item, isComponent);
        item.RequestedAction = priceListItemActionEnum.Define;
    };

    $scope.OverridePrice = function (item, isComponent) {
        ResetPrice(item, isComponent);
        item.RequestedAction = priceListItemActionEnum.Override;
    };
    
    function ResetPrice(item, isComponent) {
        item.OneOffPrice = {PricePerUnit: isComponent ? null : "", PriceScale: null, DiscountScale: null};
        item.RecurringPrice = {PricePerUnit: "", PriceScale: null, DiscountScale: null};
        item.IsOverridden = undefined;
    }

    $scope.InheritPrice = function (item) {
        item.RequestedAction = priceListItemActionEnum.Inherit;
        
        const parentItem = getItemFromParent($scope.priceList.ParentPriceListId, item.ProductId);
        if (parentItem) {
            item.OneOffPrice = {...parentItem.OneOffPrice};
            item.RecurringPrice = {...parentItem.RecurringPrice};
        }
    };

    $scope.CancelEditingPlanVariantItem = function (item) {
        const clonedItem = $scope.clonedPlanVariantPriceListItems.find(i => i.ProductId === item.ProductId);

        // In case of canceling Override action when parent item values is undefined, we need to set OneOffPrice and RecurringPrice to undefined, otherwise we are mapping values from related cloned item
        item.OneOffPrice = (!clonedItem.OneOffPrice && !clonedItem.RecurringPrice) ? undefined : {...clonedItem.OneOffPrice};
        item.RecurringPrice = (!clonedItem.OneOffPrice && !clonedItem.RecurringPrice) ? undefined : {...clonedItem.RecurringPrice};
        item.IsOverridden = clonedItem.IsOverridden;
        item.dirty = false;
        item.RequestedAction = undefined;
        $scope.unsavedItems.value--;
    };

    $scope.CancelEditingMeteredComponentItem = function (item) {
        const clonedItem = $scope.clonedMeteredComponentsPriceListItems.find(i => i.ProductId === item.ProductId);

        // In case of canceling Override action when parent item value is undefined, we need to set RecurringPrice to undefined, otherwise we are mapping value from related cloned item
        item.RecurringPrice = !clonedItem.RecurringPrice ? undefined : {...clonedItem.RecurringPrice};
        item.IsOverridden = clonedItem.IsOverridden;
        item.dirty = false;
        item.RequestedAction = undefined;
        $scope.unsavedMeteredComponentItems.value--;
    };

    $scope.CancelEditingRecurringComponentItem = function (item) {
        const clonedItem = $scope.clonedRecurringComponentsPriceListItems.find(i => i.ProductId === item.ProductId);

        // In case of canceling Override action when parent item value is undefined, we need to set RecurringPrice to undefined, otherwise we are mapping value from related cloned item
        item.RecurringPrice = !clonedItem.RecurringPrice ? undefined : {...clonedItem.RecurringPrice};
        item.IsOverridden = clonedItem.IsOverridden;
        item.dirty = false;
        item.RequestedAction = undefined;
        $scope.unsavedRecurringComponentItems.value--;
    };

    $scope.ShowDefinePriceButton = function (item, isComponent) {
        if (isComponent)
            return item.RecurringPrice == null && !$scope.IsChildPriceList();

        return item.OneOffPrice == null && item.RecurringPrice == null && !$scope.IsChildPriceList();
    }
    
    $scope.ShowOverridePriceButton = function (item) {
        if (item.IsOverridden || item.RequestedAction)
            return false;

        return $scope.IsChildPriceList();
    }

    $scope.ShowInheritPriceButton = function (item) {
        if (item.RequestedAction)
            return false;

        const parentItem = getItemFromParent($scope.priceList.ParentPriceListId, item.ProductId);

        if (!parentItem)
            return false;
        
        return !!item.IsOverridden;
    }

    $scope.ShowCancelButton = function (item) {
        return item.RequestedAction;
    };
    
    $scope.IsChildPriceList = function () {
        return !!$scope.priceList.ParentPriceListId;
    }

    $scope.IsReadOnlyItem = function (item) {
        // For cases when child uses parent item OR we want to inherit price  item will be readonly
        return (item.IsOverridden === false && $scope.IsChildPriceList()) ||
            item.RequestedAction === priceListItemActionEnum.Inherit;
    };
    
    $scope.CancelEditingPlans = function () {
        $scope.loadPlanVariantsPrices();
        $scope.unsavedItems.value = 0;
        $scope.updateFilter();
    };

    $scope.CancelEditingRecurringComponents = function () {
        $scope.loadRecurringComponentsPrices();
        $scope.unsavedRecurringComponentItems.value = 0;
        $scope.updateRecurringComponentsFilter();
    };

    $scope.CancelEditingMeteredComponents = function () {
        $scope.loadMeteredComponentsPrices();
        $scope.unsavedMeteredComponentItems.value = 0;
        $scope.updateMeteredComponentsFilter();
    };

    $scope.hidePlural = function (unsavedItems) {
        return String(unsavedItems.value).slice(-1) === "1";
    };

    $scope.getPlanName = function (priceListItem) {
        let planVariant = $scope.productInfo.PlanVariantById(priceListItem.ProductId);
        return $scope.productInfo.PlanById(planVariant.PlanId).Name;
    }
};
PriceListEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', '$q', '$uibModal', 'ProductInfo', 'PriceList', 'PriceListItems', 'babelFilter'];
